// extracted by mini-css-extract-plugin
export default {"container":"Calculo_container__3J2Sv","paper":"Calculo_paper__P2H8t","form":"Calculo_form__P3pyI","button":"Calculo_button__loA9c"};